;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.filters')
    .filter('chorusStatus', ChorusStatusFilter)

  ChorusStatusFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function ChorusStatusFilter (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (input) {
      switch (input) {
        case 'MISE_A_DISPOSITION':
          return 'Mise à disposition'
        case 'SERVICE_FAIT':
          return 'Service fait'
        case 'MANDATEE':
          return 'Mandatée'
        case 'MISE_A_DISPOSITION_COMPTABLE':
          return 'Mise à disposition comptable'
        case 'PRISE_EN_COMPTE_DESTINATAIRE':
          return 'Prise en compte destinataire'
        case 'COMPTABILISEE':
          return 'Comptabilisée'
        case 'MISE_EN_PAIEMENT':
          return 'Mise en paiement'
        case 'COMPLETEE':
          return 'Complétée'
        case 'REJETEE':
          return 'Rejetée'
        case 'DEPOSEE':
          return 'Déposée'
      }
      return input
    }
  }
})(window.angular, window._)
